import { Layers } from "appworks/graphics/layers/layers";
import { AbstractControl } from "appworks/ui/controls/abstract-control";
import { ControlFactory } from "appworks/ui/factories/control-factory";
import { TGRToggleDisabledControl } from "setup/factories/controls/tgr-toggle-disabled-control";

export class TGRToggleDisabledControlFactory implements ControlFactory {

    constructor(protected layerId: string, protected toggleId: string) { }

    public filter(layer: Layers): boolean {
        if (layer.id === this.layerId && layer.getToggle(this.toggleId)) {
            return true;
        }
        return false;
    }

    public build(layer: Layers): AbstractControl[] {
        return [new TGRToggleDisabledControl(layer.getToggle(this.toggleId))];
    }
}
